<template>
    <div class="fillcontain">
        <div class="table_container">
            <el-row>
                <el-button type="primary" @click="handleEdit(0, '','add')">新增店家</el-button>
            </el-row>
            <br/>
            <el-table
                :data="userTableData"
                style="width: 100%"
                v-loading="loading">
              <el-table-column
                label="店名"
                prop="name">
              </el-table-column>

              <el-table-column
                label="账号"
                prop="adminUser.account">
              </el-table-column>

              <el-table-column
                label="电话"
                prop="telephons">
              </el-table-column>

              <el-table-column
                label="分店数"
                prop="limitStore">
              </el-table-column>

                <el-table-column
                    label="备注"
                    prop="note"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    label="状态"
                    :formatter="rreezeFormat">
                </el-table-column>

                <el-table-column label="操作" width="260">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="handleEdit(scope.$index, scope.row,'edit')">
                        编辑
                    </el-button>
                    <el-button
                      size="mini"
                      type="warning"
                      style="margin: 5px"
                      @click="handleResetPwdAlert( scope.row)">
                      重置密码
                    </el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="handleDeleteAlert( scope.row)">
                      删除
                    </el-button>
                  </template>
                </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pages.page"
                  :page-size="pages.pageSize"
                  layout="total, prev, pager, next"
                  :total="pages.total">
                </el-pagination>
            </div>

            <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" :close-on-click-modal="dialog.close">
                <el-form :model="admin">

                    <el-form-item label="账号" label-width="100px">
                        <el-input v-model="admin.account" auto-complete="off"></el-input>
                    </el-form-item>
                  <el-form-item label="账号前缀" label-width="100px">
                    <el-input v-model="admin.storePrefix" auto-complete="off"></el-input>
                  </el-form-item>
                    <el-form-item label="店名" label-width="100px">
                        <el-input v-model="admin.name" auto-complete="off"></el-input>
                    </el-form-item>

                  <el-form-item label="省" label-width="100px">
                    <el-input v-model="admin.province" auto-complete="off"></el-input>
                  </el-form-item>

                  <el-form-item label="市" label-width="100px">
                    <el-input v-model="admin.city" auto-complete="off"></el-input>
                  </el-form-item>

                  <el-form-item label="区" label-width="100px">
                    <el-input v-model="admin.area" auto-complete="off"></el-input>
                  </el-form-item>

                  <el-form-item label="地址" label-width="100px">
                    <el-input v-model="admin.address" type="textarea" rows="4"></el-input>
                  </el-form-item>

                  <el-form-item label="电话" label-width="100px">
                    <el-input v-model="admin.telephons" auto-complete="off"></el-input>
                  </el-form-item>

                  <el-form-item label="分店数" label-width="100px">
                    <el-input-number v-model="admin.limitStore"></el-input-number>
                  </el-form-item>

                  <el-form-item label="备注" label-width="100px">
                    <el-input v-model="admin.note" type="textarea" rows="4"></el-input>
                  </el-form-item>

                  <el-form-item label="状态" label-width="100px">
                    <el-radio v-model="admin.status" label="1">正常</el-radio>
                    <el-radio v-model="admin.status" label="2">关闭</el-radio>
                  </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleSave">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                loading:false,
                admin:{
                    id:0,
                    account:"",
                    storePrefix:"",
                    name:"",
                    province:"",
                    city:"",
                    area:"",
                    address:"",
                    telephons:"",
                    limitStore:"",
                    status:"1",
                    note:"",
                },
                dialog:{
                    dialogFormVisible:false,
                    title:"新增店家",
                    close:false,
                },
                pages:{
                    offset: 0,
                    pageSize: 10,
                    page: 1,
                    total: 0,
                },
                userTableData: [],

            }
        },
        created(){
            this.initData();
        },
        methods: {
            initData(){
              this.loading = true;
              var that = this;
              that.$api.get('/super_admin/main_store', that.pages, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.userTableData = res.data.main_store.content;
                    that.pages.total = res.data.main_store.totalElements;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },

            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.pages.page = val;
                this.pages.offset = (val - 1)*this.pages.pageSize;
                this.initData()
            },
            rreezeFormat(row,column){
              if(row.status == 1){
                return "正常";
              }else{
                return "关闭"
              }
            },
            handleEdit(index, row,action) {
                if(action == "edit"){
                    this.dialog.title = "修改店家";
                    this.admin.id = row.id;
                    this.admin.account = row.adminUser.account;
                    this.admin.name = row.name;
                    this.admin.province = row.province;
                    this.admin.city = row.city;
                    this.admin.area = row.area;
                    this.admin.address = row.address;
                    this.admin.telephons = row.telephons;
                    this.admin.limitStore = row.limitStore;
                    this.admin.note = row.note;
                    this.admin.status = ""+row.status;
                    this.admin.storePrefix = row.storePrefix;

                    this.dialog.dialogFormVisible = true;
                }else if(action == "add"){
                    this.dialog.title = "新增店家";
                    this.admin.id = 0;
                    this.admin.account = "";
                    this.admin.name = "";
                    this.admin.province = "";
                    this.admin.city = "";
                    this.admin.area = "";
                    this.admin.address = "";
                    this.admin.telephons = "";
                    this.admin.limitStore = 1;
                    this.admin.note = "";
                    this.admin.status = "1";
                    this.admin.storePrefix ="",
                    this.dialog.dialogFormVisible = true;
                }
            },
            handleSave() {
                this.loading = true;
                var that = this;
                that.$api.post('/super_admin/main_store', that.admin, response => {
                  if (response.status >= 200 && response.status < 300) {
                    console.log(response.data);
                    var res = response.data;
                    if (res.code == 0) {
                      this.$message({
                        message: that.dialog.title+'成功',
                        type: 'success'
                      });
                      this.dialog.dialogFormVisible = false;
                      this.initData();
                    }else{
                      this.$message({
                        message: res.msg,
                        type: 'warning'
                      });
                    }
                  } else {
                    this.$message({
                      message: "服务器维护中",
                      type: 'error'
                    });
                  }

                });

                this.loading = false;
            },
            handleDeleteAlert(row) {
                this.$confirm('此操作将删除该店家, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.handleDelete(row);
                }).catch(() => {

                });
            },
          handleDelete(row) {
            this.loading = true;
            var that = this;
            that.$api.delete('/super_admin/main_store/'+row.id, null, response => {
              if (response.status >= 200 && response.status < 300) {
                  console.log(response.data);
                  var res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.loading = false;
                    this.initData();
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
              } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
              }

            });
            },

          handleResetPwdAlert(row) {
            this.$confirm('此操作将重置该总店管理员的密码为:888888, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.handleResetPwd(row);
            }).catch(() => {

            });
          },

          handleResetPwd(row) {
            this.loading = true;
            var that = this;
            that.$api.put('/super_admin/main_store/reset_password/'+row.id, null, response => {
              if (response.status >= 200 && response.status < 300) {
                console.log(response.data);
                var res = response.data;
                if (res.code == 0) {
                  this.$message({
                    message: '重置成功,请立即使用默认密码:888888 登录修改密码',
                    type: 'success',

                  });
                  //this.initData();
                }else{
                  this.$message({
                    message: res.msg,
                    type: 'warning'
                  });
                }
              } else {
                this.$message({
                  message: "服务器维护中",
                  type: 'error'
                });
              }

              this.loading = false;

            });
          },
        },
    }
</script>

<style lang="less">
	@import '../../style/mixin';
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .table_container{
        padding: 20px;
    }
    .Pagination{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/superAdmin/MainStore.vue